module.exports = __webpack_public_path__ + "static/img/img02.9a89d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en008/img02.jpg
// module id = 49Gx
// module chunks = 0